/**
 * 검색 API 모델
 *
 * OpenAPI generator 로 만들던 타입을 실제 사용하는 것만 추려 옮긴 파일이다.
 * 서버 스펙 변경 시 직접 수정한다.
 */

export interface CatalogModel {
  count: number;
  imageUrl: string;
  modelName: string;
  soldCount: number;
  avgPrice?: number;
  readyToShip: boolean;
  appUrl: string;
  minPrice?: number;
  brandId: number;
  modelId: number;
  tracking: Tracking;
  type: CatalogModelTypeEnum;
}

export interface CatalogModelContainer {
  title: string;
  appUrl: string;
  models: Array<CatalogModel>;
  position: number;
}

export const CatalogModelTypeEnum = {
  Product: 'PRODUCT',
  Model: 'MODEL',
  ExtAd: 'EXT_AD',
  Mercari: 'MERCARI',
} as const;
export type CatalogModelTypeEnum = (typeof CatalogModelTypeEnum)[keyof typeof CatalogModelTypeEnum];

export interface CatalogModelV2 {
  appUrl: string;
  modelId: number;
  modelName: string;
  brandId: number;
  count: number;
  soldCount: number;
  minPrice?: number;
  avgPrice?: number;
  imageUrl: string;
  readyToShip: boolean;
  type: CatalogModelV2TypeEnum;
  tracking: Tracking;
}

export const CatalogModelV2TypeEnum = {
  Product: 'PRODUCT',
  Model: 'MODEL',
  ExtAd: 'EXT_AD',
  Mercari: 'MERCARI',
} as const;
export type CatalogModelV2TypeEnum = (typeof CatalogModelV2TypeEnum)[keyof typeof CatalogModelV2TypeEnum];

export interface ContainerShortform {
  id: number;
  url: string;
  thumbnailImage?: string;
  viewCount?: number;
  viewCountDisplayText: string;
  products: Array<ContainerShortformProduct>;
  tracking?: Tracking;
}

export interface ContainerShortformProduct {
  pid: number;
}

export interface ExternalAdV2 {
  appUrl: string;
  name: string;
  imageUrl: string;
  webUrl: string;
  price: number;
  priceSuffix?: string;
  storeName?: string;
  adText?: string;
  tracking: Tracking;
  type: ExternalAdV2TypeEnum;
}

export const ExternalAdV2TypeEnum = {
  Product: 'PRODUCT',
  Model: 'MODEL',
  ExtAd: 'EXT_AD',
  Mercari: 'MERCARI',
} as const;
export type ExternalAdV2TypeEnum = (typeof ExternalAdV2TypeEnum)[keyof typeof ExternalAdV2TypeEnum];

export interface FilterValue {
  name: string;
  subName?: string;
  key?: string;
  value?: string;
  count?: number;
  _default?: boolean;
  children?: Array<FilterValue>;
  addressCode?: string;
  addressId?: number;
  buyDistance?: number;
  lat?: number;
  lon?: number;
  isConfirmed?: boolean;
}

export interface ProductData {
  ad: boolean;
  adult: boolean;
  appUrl?: string;
  brandId?: number;
  buntalkCount?: number;
  care: boolean;
  catalog?: ProductDataCatalog;
  category?: ProductDataSimpleCategory;
  commentCount?: number;
  condition?: ProductDataConditionEnum;
  contact?: boolean;
  createdAt?: Date; // 생성일시
  createdBefore?: string;
  exchange?: boolean;
  faved: boolean;
  favoriteCount?: number;
  freeShipping?: boolean;
  hidden: boolean;
  inspection?: ProductDataInspectionEnum;
  keywords?: Array<string>;
  location?: string;
  matched?: Array<string>; // 매칭된 query label
  modifiedAt?: Date; // 수정일시
  modifiedBefore?: string;
  name: string;
  namePrefix?: string;
  nearBy?: boolean;
  options?: ProductOptions;
  pid: number;
  popularScore?: number;
  price: number;
  productImage: string;
  status: ProductDataStatusEnum;
  tracking: Tracking;
  type: ProductDataTypeEnum;
  updatedAt?: Date; // 광고 등으로 인한 갱신일시
  updatedBefore?: string;
  user?: ProductDataShop;
  viewCount?: number;
}

export interface ProductDataBrand {
  id: number;
  nameKor: string;
  nameEng: string;
  imgUrl: string;
  followed?: boolean;
}

export interface ProductDataCatalog {
  modelId?: number;
}

export interface ProductDataCategory {
  id?: string;
  title?: string;
  iconUrl?: string;
  categories?: Array<ProductDataCategory>;
  count?: number;
}

export const ProductDataConditionEnum = {
  Undefined: 'UNDEFINED',
  Used: 'USED',
  New: 'NEW',
  LikeNew: 'LIKE_NEW',
  LightlyUsed: 'LIGHTLY_USED',
  HeavilyUsed: 'HEAVILY_USED',
  Damaged: 'DAMAGED',
} as const;
export type ProductDataConditionEnum = (typeof ProductDataConditionEnum)[keyof typeof ProductDataConditionEnum];

export interface ProductDataDiscount {
  rate?: number;
  originPrice?: number;
  endAt?: Date;
}

export const ProductDataInspectionEnum = {
  OptOut: 'OPT_OUT',
  OptIn: 'OPT_IN',
  NonTarget: 'NON_TARGET',
  Inspected: 'INSPECTED',
} as const;
export type ProductDataInspectionEnum = (typeof ProductDataInspectionEnum)[keyof typeof ProductDataInspectionEnum];

export interface ProductDataShop {
  uid?: number;
  name?: string;
  image?: string;
  proshop: boolean;
  restrictions?: Array<ProductDataShopRestrictionsEnum>;
}

export const ProductDataShopRestrictionsEnum = {
  Blocked: 'BLOCKED',
  ProshopRestrict: 'PROSHOP_RESTRICT',
  SaleRestrict: 'SALE_RESTRICT',
} as const;
export type ProductDataShopRestrictionsEnum =
  (typeof ProductDataShopRestrictionsEnum)[keyof typeof ProductDataShopRestrictionsEnum];

export interface ProductDataSimpleCategory {
  id: string;
  name: string;
}

export const ProductDataStatusEnum = {
  Selling: 'SELLING',
  Reserved: 'RESERVED',
  Deleted: 'DELETED',
  SoldOut: 'SOLD_OUT',
} as const;
export type ProductDataStatusEnum = (typeof ProductDataStatusEnum)[keyof typeof ProductDataStatusEnum];

export const ProductDataTypeEnum = {
  Product: 'PRODUCT',
  Model: 'MODEL',
  ExtAd: 'EXT_AD',
  Mercari: 'MERCARI',
} as const;
export type ProductDataTypeEnum = (typeof ProductDataTypeEnum)[keyof typeof ProductDataTypeEnum];

export interface ProductDataV2 {
  ad: boolean;
  adult: boolean;
  appUrl?: string;
  brandId?: number;
  buntalkCount?: number;
  care: boolean;
  catalog?: ProductDataCatalog;
  category?: ProductDataSimpleCategory;
  commentCount?: number;
  condition?: ProductDataV2ConditionEnum;
  contact?: boolean;
  createdAt?: Date; // 생성일시
  discount?: ProductDataDiscount;
  exchange?: boolean;
  faved: boolean;
  favoriteCount?: number;
  freeShipping?: boolean;
  hidden: boolean;
  inspection?: ProductDataV2InspectionEnum;
  keywords?: Array<string>;
  location?: string;
  matched?: Array<string>; // 매칭된 query label
  modifiedAt?: Date; // 수정일시
  name: string;
  namePrefix?: string;
  nearBy?: boolean;
  options?: ProductOptions;
  payload?: string;
  pid: number;
  popularScore?: number;
  price: number;
  priceTopArea?: ProductDataV2PriceTopArea;
  productImage: string;
  saleType?: ProductDataV2SaleTypeEnum;
  status: ProductDataV2StatusEnum;
  tracking: Tracking;
  type: ProductDataV2TypeEnum;
  updatedAt?: Date; // 광고 등으로 인한 갱신일시
  user?: ProductDataShop;
  video: boolean;
  viewCount?: number;
  createdBefore?: string;
  modifiedBefore?: string;
  updatedBefore?: string;
}

export const ProductDataV2ConditionEnum = {
  Undefined: 'UNDEFINED',
  Used: 'USED',
  New: 'NEW',
  LikeNew: 'LIKE_NEW',
  LightlyUsed: 'LIGHTLY_USED',
  HeavilyUsed: 'HEAVILY_USED',
  Damaged: 'DAMAGED',
} as const;
export type ProductDataV2ConditionEnum = (typeof ProductDataV2ConditionEnum)[keyof typeof ProductDataV2ConditionEnum];

export const ProductDataV2InspectionEnum = {
  OptOut: 'OPT_OUT',
  OptIn: 'OPT_IN',
  NonTarget: 'NON_TARGET',
  Inspected: 'INSPECTED',
} as const;
export type ProductDataV2InspectionEnum =
  (typeof ProductDataV2InspectionEnum)[keyof typeof ProductDataV2InspectionEnum];

export interface ProductDataV2PriceTopArea {
  text: string;
  reduction: string;
}

export const ProductDataV2SaleTypeEnum = {
  TimeSale: 'TIME_SALE',
} as const;
export type ProductDataV2SaleTypeEnum = (typeof ProductDataV2SaleTypeEnum)[keyof typeof ProductDataV2SaleTypeEnum];

export const ProductDataV2StatusEnum = {
  Selling: 'SELLING',
  Reserved: 'RESERVED',
  Deleted: 'DELETED',
  SoldOut: 'SOLD_OUT',
} as const;
export type ProductDataV2StatusEnum = (typeof ProductDataV2StatusEnum)[keyof typeof ProductDataV2StatusEnum];

export const ProductDataV2TypeEnum = {
  Product: 'PRODUCT',
  Model: 'MODEL',
  ExtAd: 'EXT_AD',
  Mercari: 'MERCARI',
} as const;
export type ProductDataV2TypeEnum = (typeof ProductDataV2TypeEnum)[keyof typeof ProductDataV2TypeEnum];

export interface ProductOptions {
  shoeSize?: string;
  components?: Array<ProductOptionsComponentsEnum>;
}

export const ProductOptionsComponentsEnum = {
  Box: 'BOX',
  Shoelace: 'SHOELACE',
  Insole: 'INSOLE',
  Guarantee: 'GUARANTEE',
  GuaranteeCard: 'GUARANTEE_CARD',
  DustBag: 'DUST_BAG',
} as const;
export type ProductOptionsComponentsEnum =
  (typeof ProductOptionsComponentsEnum)[keyof typeof ProductOptionsComponentsEnum];

export interface RankedKeyword {
  keyword: string;
  ranking: string;
  shift?: RankedKeywordShiftEnum;
}

export const RankedKeywordShiftEnum = {
  Up: 'UP',
  Down: 'DOWN',
  New: 'NEW',
  None: 'NONE',
} as const;
export type RankedKeywordShiftEnum = (typeof RankedKeywordShiftEnum)[keyof typeof RankedKeywordShiftEnum];

export interface RecKeywordResponseData {
  keywords?: Array<string>;
  impId?: string;
  refCode?: string;
  refContent?: string;
}

export interface RelatedKeyword {
  name: string;
  rank: number;
}

export interface SearchFilter {
  id: string;
  name: string;
  shortcut: boolean;
  highlight: boolean;
  key?: string;
  value?: string;
  type?: SearchFilterTypeEnum;
  inputType?: SearchFilterInputTypeEnum;
  selectType?: SearchFilterSelectTypeEnum;
  maxSize?: number;
  values?: Array<FilterValue>;
  guideMessage?: string;
}

export const SearchFilterInputTypeEnum = {
  Button: 'BUTTON',
  Radio: 'RADIO',
  Checkbox: 'CHECKBOX',
  Text: 'TEXT',
  Digit: 'DIGIT',
} as const;
export type SearchFilterInputTypeEnum = (typeof SearchFilterInputTypeEnum)[keyof typeof SearchFilterInputTypeEnum];

export const SearchFilterSelectTypeEnum = {
  Single: 'SINGLE',
  Multi: 'MULTI',
} as const;
export type SearchFilterSelectTypeEnum = (typeof SearchFilterSelectTypeEnum)[keyof typeof SearchFilterSelectTypeEnum];

export const SearchFilterTypeEnum = {
  SingleButton: 'SINGLE_BUTTON',
  SingleRound: 'SINGLE_ROUND',
  MultiCheck: 'MULTI_CHECK',
  MultiCheckV2: 'MULTI_CHECK_V2',
} as const;
export type SearchFilterTypeEnum = (typeof SearchFilterTypeEnum)[keyof typeof SearchFilterTypeEnum];

export type SearchItem = CatalogModelV2 | ExternalAdV2 | ProductDataV2;

export interface SearchProductsParams {
  page: number;
  ref: SearchRefEnum;
  size?: number;
  sort?: SearchSortEnum;
  a?: Array<number>;
  q?: string;
  within?: string;
  requestId?: string;
  uid?: Array<number>;
  pid?: Array<number>;
  status?: Array<SearchStatusEnum>;
  maxCreatedAt?: string;
  minCreatedAt?: string;
  maxModifiedAt?: string;
  minModifiedAt?: string;
  maxUpdatedAt?: string;
  minUpdatedAt?: string;
  categoryId?: Array<string>;
  used?: boolean;
  brandId?: Array<number>;
  soldout?: SearchSoldoutEnum;
  excludePid?: Array<number>;
  filters?: boolean;
  qvalid?: boolean;
}

export interface SearchProductsResponse {
  size?: number; // 요청된 페이지 사이즈
  totalPages?: number;
  totalElements?: number;
  sort?: SearchProductsResponseSortEnum;
  after?: Array<object>;
  nextCursor?: string;
  filters?: Array<SearchFilter>;
  tabs?: Array<SearchTab>;
  relatedKeywords?: Array<RelatedKeyword>;
  data?: Array<SearchItem>;
  category?: ProductDataCategory;
  brand?: ProductDataBrand;
  message?: TextModel;
  hint?: TextModel;
  guide?: Array<TextModel>;
  recKeyword?: RecKeywordResponseData;
  recProducts?: Array<ProductData>;
  modelContainer?: CatalogModelContainer;
  shortformContainers?: Array<ShortformContainer>;
  suggestionFilter?: SuggestionFilterContainer;
  rec?: boolean;
  responseCode?: string;
}

export const SearchProductsResponseSortEnum = {
  Date: 'date',
  RawDate: 'raw_date',
  Distance: 'distance',
  Score: 'score',
  Model: 'model',
  Popular: 'popular',
  PriceAsc: 'price_asc',
  PriceDesc: 'price_desc',
  PfavcntDesc: 'pfavcnt_desc',
  InterestDesc: 'interest_desc',
  CreateDateAsc: 'create_date_asc',
  CreateDateDesc: 'create_date_desc',
  ModifiedDesc: 'modified_desc',
  ModifiedAsc: 'modified_asc',
  DiscountStartedDesc: 'discount_started_desc',
  DiscountRateDesc: 'discount_rate_desc',
  DiscountEndAsc: 'discount_end_asc',
  Unknown: 'unknown',
  None: 'none',
} as const;
export type SearchProductsResponseSortEnum =
  (typeof SearchProductsResponseSortEnum)[keyof typeof SearchProductsResponseSortEnum];

export const SearchRefEnum = {
  Search: 'search',
  Shop: 'shop',
  Admin: 'admin',
  Category: 'category',
  Latest: 'latest',
} as const;
export type SearchRefEnum = (typeof SearchRefEnum)[keyof typeof SearchRefEnum];

export interface SearchShopProductsParams {
  shopId: string;
  page: number;
  size?: number;
  sort?: SearchSortEnum;
  a?: Array<number>;
  q?: string;
  within?: string;
  requestId?: string;
  maxCreatedAt?: string;
  minCreatedAt?: string;
  categoryId?: Array<string>;
  used?: boolean;
  brandId?: Array<number>;
  filters?: boolean;
  qvalid?: boolean;
}

export const SearchSoldoutEnum = {
  Include: 'include',
  Exclude: 'exclude',
} as const;
export type SearchSoldoutEnum = (typeof SearchSoldoutEnum)[keyof typeof SearchSoldoutEnum];

export const SearchSortEnum = {
  Date: 'date',
  RawDate: 'raw_date',
  Distance: 'distance',
  Score: 'score',
  Model: 'model',
  Popular: 'popular',
  PriceAsc: 'price_asc',
  PriceDesc: 'price_desc',
  PfavcntDesc: 'pfavcnt_desc',
  InterestDesc: 'interest_desc',
  CreateDateAsc: 'create_date_asc',
  CreateDateDesc: 'create_date_desc',
  ModifiedDesc: 'modified_desc',
  ModifiedAsc: 'modified_asc',
  DiscountStartedDesc: 'discount_started_desc',
  DiscountRateDesc: 'discount_rate_desc',
  DiscountEndAsc: 'discount_end_asc',
  Unknown: 'unknown',
  None: 'none',
} as const;
export type SearchSortEnum = (typeof SearchSortEnum)[keyof typeof SearchSortEnum];

export const SearchStatusEnum = {
  Selling: 'SELLING',
  Reserved: 'RESERVED',
  Deleted: 'DELETED',
  SoldOut: 'SOLD_OUT',
} as const;
export type SearchStatusEnum = (typeof SearchStatusEnum)[keyof typeof SearchStatusEnum];

export interface SearchTab {
  type: SearchTabTypeEnum;
  name: string;
}

export const SearchTabTypeEnum = {
  Product: 'PRODUCT',
  Model: 'MODEL',
  Mercari: 'MERCARI',
  Unknown: 'UNKNOWN',
} as const;
export type SearchTabTypeEnum = (typeof SearchTabTypeEnum)[keyof typeof SearchTabTypeEnum];

export interface ShortformContainer {
  title: string;
  data: Array<ContainerShortform>;
  rowPosition: number;
}

export interface SuggestedCategory {
  categoryId: string;
  desc: string;
  shortDesc?: string;
  imgUrl?: string;
  keyword: string;
}

export interface SuggestedKeywords {
  categories?: Array<SuggestedCategory>;
  keywords?: Array<string>;
}

export interface SuggestedKeywordsParams {
  q?: string;
}

export interface SuggestedKeywordsResponse {
  data?: SuggestedKeywords;
}

export interface SuggestionFilter {
  appUrl: string | null;
  title?: string | null;
  imgUrl?: string | null;
  categoryId?: string | null;
}

export interface SuggestionFilterContainer {
  title: string;
  type: SuggestionFilterContainerTypeEnum;
  filters: Array<SuggestionFilter>;
}

export const SuggestionFilterContainerTypeEnum = {
  Bubble: 'BUBBLE',
  Text: 'TEXT',
  Card: 'CARD',
} as const;
export type SuggestionFilterContainerTypeEnum =
  (typeof SuggestionFilterContainerTypeEnum)[keyof typeof SuggestionFilterContainerTypeEnum];

export interface Text {
  key?: string;
  text: string;
  attribute?: TextAttribute;
  appUrl?: string;
}

export interface TextAttribute {
  color: TextAttributeColor;
  typography?: TextAttributeTypographyEnum;
  style?: TextAttributeStyleEnum;
}

export interface TextAttributeColor {
  red?: number;
  green?: number;
  blue?: number;
  alpha?: number;
  rgb?: number;
  colorSpace?: TextAttributeColorColorSpace;
  transparency?: number;
}

export interface TextAttributeColorColorSpace {
  type?: number;
  numComponents?: number;
  cs_sRGB?: boolean;
}

export const TextAttributeStyleEnum = {
  Underline: 'underline',
  Strikethrough: 'strikethrough',
} as const;
export type TextAttributeStyleEnum = (typeof TextAttributeStyleEnum)[keyof typeof TextAttributeStyleEnum];

export const TextAttributeTypographyEnum = {
  T1: 'T1',
  T2: 'T2',
  T3: 'T3',
  T4: 'T4',
  S1: 'S1',
  S2: 'S2',
  S3: 'S3',
  S4: 'S4',
  B1: 'B1',
  B3: 'B3',
  B5: 'B5',
  C1: 'C1',
  C2: 'C2',
  C3: 'C3',
  C4: 'C4',
  C5: 'C5',
  L1: 'L1',
  L2: 'L2',
  L3: 'L3',
  L4: 'L4',
  L5: 'L5',
  L6: 'L6',
  L7: 'L7',
  L8: 'L8',
  L9: 'L9',
  L10: 'L10',
  L11: 'L11',
  L12: 'L12',
  L13: 'L13',
  L14: 'L14',
} as const;
export type TextAttributeTypographyEnum =
  (typeof TextAttributeTypographyEnum)[keyof typeof TextAttributeTypographyEnum];

export interface TextModel {
  main: Text;
  sub?: Array<Text>;
}

export interface Tracking {
  imp_id: string;
  ref_code?: string;
  ref_source?: string;
  ref_medium?: string;
  ref_campaign?: string;
  ref_content?: string;
  ref_test?: string;
  request_id?: string;
}
